import { Reisperiode } from "@/entities/tvv";
import { z } from "zod";

export const editBestellingSchema = z.object({
    reisperiode: z.enum(Reisperiode),
    busFrequentie: z.coerce.number<number>().min(1, "Minimaal 1"),
    aantalBussen: z.coerce.number<number>().min(1, "Minimaal 1"),
    aantalBussenOpBeginStation: z.coerce.number<number>().min(0),
    isAangepast: z.boolean(),
});

export type EditBestellingData = z.infer<typeof editBestellingSchema>;

export const editOvRouteSchema = z.object({
    ovLijnNummer: z.string().min(1, "Vul een lijnnummer in"),
});

export type EditOvRouteData = z.infer<typeof editOvRouteSchema>;
